module.exports = __webpack_public_path__ + "696b6562989721e36cb554543f80c21d.png";